import React from 'react';

const MailCard = ({ mail, onFilterClick }) => {
  const getStatusColor = (status) => {
    if (!status) return "secondary";
    const s = status.toLowerCase();
    if (s.includes('pass')) return "success";
    if (s.includes('fail')) return "danger";
    return "warning";
  };

  const formatTime = (dateValue) => {
    try {
      if (!dateValue) return "--:--";
      
      let date;
      if (!isNaN(dateValue) && !String(dateValue).includes('-')) {
        date = new Date(parseInt(dateValue, 10));
      } else {
        date = new Date(dateValue);
      }

      if (isNaN(date.getTime())) return "--:--"; 
      
      return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
    } catch (e) {
      return "Err";
    }
  };

  const isSpam = mail.folderName?.toLowerCase().includes('spam');
  const folderName = mail.folderName || 'INBOX';

  const handleFilter = (e, val) => {
    e.stopPropagation();
    if (onFilterClick && val && val !== 'N/A') {
      onFilterClick(String(val));
    }
  };

  return (
    <div className="card shadow-sm mb-2" style={{ minWidth: '280px', maxWidth: '280px', flexShrink: 0, borderRadius: '8px', border: 'none' }}>
      <div className="card-body p-3">
        
        {/* Header: Subject + Folder Badge */}
        <div className="d-flex justify-content-between align-items-start mb-2">
          <h6 
            className="card-title text-truncate mb-0 fw-bold clickable-filter" 
            style={{maxWidth: '70%', fontSize: '14px'}} 
            title={mail.subject}
            onClick={(e) => handleFilter(e, mail.subject)}
          >
            {mail.subject || "No Subject"}
          </h6>
          <span className={`badge ${isSpam ? 'bg-danger' : 'bg-primary'} bg-opacity-75`} style={{fontSize: '9px', padding: '4px 8px'}}>
            {folderName.toUpperCase()}
          </span>
        </div>

        <p className="card-text small text-muted mb-2 text-truncate" style={{fontSize: '11px'}}>
          <span className="fw-bold">From:</span> 
          <span 
            className="ms-1 clickable-filter" 
            onClick={(e) => handleFilter(e, mail.sender)}
          >
            {mail.sender}
          </span>
        </p>

        {/* IP & Domain Info + Time */}
        <div className="d-flex justify-content-between align-items-end mb-2">
          <div className="flex-grow-1">
            <span 
              className="badge bg-light text-dark border d-inline-block mb-1 me-1 clickable-filter" 
              style={{fontSize: '10px', fontWeight: '500'}}
              onClick={(e) => handleFilter(e, mail.originIp)}
            >
              {mail.originIp || "N/A"}
            </span>
            <span 
              className="badge bg-light text-dark border d-inline-block clickable-filter" 
              style={{fontSize: '10px', fontWeight: '500'}}
              onClick={(e) => handleFilter(e, mail.domain)}
            >
              {mail.domain || "N/A"}
            </span>
          </div>
          <small className="text-muted fw-bold" style={{fontSize: '10px'}}>
            {formatTime(mail.receivedDate)}
          </small>
        </div>         

        {/* Security Badges */}
        <div className="d-flex gap-1 flex-wrap border-top pt-2">
          <span className={`badge bg-${getStatusColor(mail.spfStatus)}`} style={{fontSize: '9px', padding: '3px 6px'}}>
            SPF: {mail.spfStatus?.split(' ')[0] || '?'}
          </span>
          <span className={`badge bg-${getStatusColor(mail.dkimStatus)}`} style={{fontSize: '9px', padding: '3px 6px'}}>
            DKIM: {mail.dkimStatus?.split(' ')[0] || '?'}
          </span>
          <span className={`badge bg-${getStatusColor(mail.dmarcStatus)}`} style={{fontSize: '9px', padding: '3px 6px'}}>
            DMARC: {mail.dmarcStatus?.split(' ')[0] || '?'}
          </span>
        </div>
      </div>
    </div>
  );
};

export default MailCard;